module.exports = __webpack_public_path__ + "img/number_3.113c5cc6.png";